<template>
  <div class="authorBox">
    <div class="authorTxt">正在登录，请稍后...</div>
  </div>
</template>

<script>
import storage from '@/common/storage'

export default {
    created() {
        this.loginAuthor()
    },
    methods: {
        /* 登录授权 */
        loginAuthor() {
            this.axios({
                url: this.api.wxapp.index
            }).then(res => {
                 console.log(res);
                if (res.url) {
                    window.location.href = res.url
                } else if (res.success === 1) {
                    /* 跳回之前页面 */
                    let url = storage.s_getItem('beforeLoginUrl')
                    if (!url || url.indexOf('/author') !== -1) {
                        router.push('/index')
                    } else {
                        if (url === '/') { url = '/index' }
                        router.push(url)
                        storage.s_setItem('beforeLoginUrl', '')
                    }

                }
            })
        }
    }
}
</script>

<style scoped>
.authorBox {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.authorTxt {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 30px;
  border-radius: 30px;
  background-color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
  padding: 0 10px;
  color: #fff;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/author/author.vue